export default __webpack_public_path__ + "static/media/Rishit Dagil.0dcb5d68.jpg";